import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { getVatById } from '../invoice-tool-helper';
import { toMoney } from '../amount/amount-helper';
import { Spinner, GeneralError } from 'components';
var _ = require('lodash');

export class PreviewInvoice extends React.Component {

  static propTypes = {
    params: PropTypes.object,
    previewInvoice: PropTypes.object,
    closePreviewModal: PropTypes.func
  };

  static contextTypes = {
    user: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired
  };

  constructor (props, context) {
    super(props, context);

    this.state = {
      invoice: null,
      user: context.user,
      fetching: true,
      fetchError: false
    };
  }

  componentWillReceiveProps (nextProps) {
    if (!_.isEqual(nextProps, this.props)) {
      this.setState({ invoice: nextProps.previewInvoice });
    }
  }

  componentDidMount () {
    this.setState({
      fetching: false,
      fetchError: false,
      invoice: this.props.previewInvoice
    });
  }

  render () {
    let content = this.getContent();

    return (
      <div className='invoice'>
        {content}
      </div>
    );
  }

  getContent () {
    if (this.state.fetching) {
      return (this.renderLoader());
    }
    if (this.state.fetchError) {
      return (<GeneralError />);
    }

    return this.renderInvoicePreview();
  }

  renderLoader () {
    return (
      <div className='loader-wrapper'>
        <Spinner />
      </div>
    );
  }

  renderInvoicePreview () {
    return (
      <div>
        <div className='container ff-doc'>
          <div className={'row ' + (this.isEuNonSeCustomer() ? 'ff-no-margin-bottom' : 'invoice-header')}>
            <div className='col-sm-6'>
              <object className='ff-logo' type="image/svg+xml"
                data={require('images/logos/logo-invoice.svg')}
                alt='Frilans Finans-logotyp'>
                <img className='ff-logo' src={require('images/logos/logo-invoice.png')} alt="Frilans Finans-logotyp"/>
              </object>
            </div>
            <div className="col-sm-6">
              {this.renderInvoicePreviewCustomerDetails()}
            </div>
          </div>
          {this.renderInvoiceReferenceDetails()}
          <div className="ff-label">
            <div>
              <p className="ff-text-left"><Translate content='INVOICE_DESCRIPTION'/></p>
            </div>
            <div>
              <p className="ff-text-right"><Translate content='INVOICE_TOTAL_EXCL_VAT'/></p>
            </div>
          </div>
          {this.renderInvoiceDescription()}
          {this.renderInvoicePayment()}
          <div className="adress-box">
            <div className='ff-footer-text ff-text-left'>
              Frilans Finans Sverige AB<br/>
              Dag Hammarskjölds väg 13, 752 37 Uppsala<br/>
              Tel: +46(0)771151000<br/>
              info@frilansfinans.se<br/>
            </div>
            <div className="ff-footer-text ff-text-left">
              {!this.isForeignCustomer() &&
                <span>
                  Org.nr/Momsreg.nr<br/>
                  556802-1199<br/>
                  SE556802119901<br/>
                  Godkänd för F-skatt<br/>
                  Säte i Uppsala
                </span>
              }
              {this.isForeignCustomer() &&
                <span>
                  Org No./VAT No.<br/>
                  556802-1199<br/>
                  SE556802119901<br/>
                  Approved for F-skatt<br/>
                  Seated in Uppsala
                </span>
              }
            </div>
            <div className="ff-footer-text ff-text-left ff-text-bold">
              <Translate content='INVOICE_BANKGIRO'/> <Translate content='INVOICE_TOOL_GIRO'/><br/>
              <Translate content='INVOICE_SWIFT_NO'/> <Translate content='INVOICE_TOOL_BIC'/><br/>
              <Translate content='INVOICE_IBAN_NO'/> <Translate content='INVOICE_TOOL_IBAN'/><br/>
              <Translate content='INVOICE_BANK_ACCOUNT_NO'/> <Translate content='INVOICE_TOOL_ACCOUNT_NUMBER'/><br/>
            </div>
          </div>
          {this.renderInvoicePreviewClose()}
        </div>
      </div>
    );
  }

  renderInvoicePreviewCustomerDetails () {
    let invoice = this.state.invoice;

    return (
      <div>
        <div className="faktura-box">
          <div>
            <h4 className="ff-text-left"><Translate content='invoice'/></h4>
          </div>
          <div>
            <p className="ff-text-left"><Translate content='INVOICE_OCR_NUMBER'/></p>
            <p className="ff-text-left ff-text-large"><Translate content='ADDED_LATER'/></p>
          </div>
          <div>
            <p><Translate content='INVOICE_INVOICE_NO'/></p>
            <p className="ff-text-large"><Translate content='ADDED_LATER'/></p>
          </div>
          <div>
            <p><Translate content='INVOICE_DATE'/></p>
            <p className="ff-text-large"><Translate content='ADDED_LATER'/></p>
          </div>
        </div>
        <div className="ff-customer-adress ff-text-left">
          <p className="ff-text-large">{invoice.customerEntity.name}</p>
          <p className="ff-text-large">{invoice.customerEntity.address.co.trim().length
            ? <span>{invoice.customerEntity.address.co}</span>
            : null}
          </p>
          <p className="ff-text-large">{invoice.customerEntity.address.street}</p>
          <p className="ff-text-large">{invoice.customerEntity.address.zip} {invoice.customerEntity.address.city}</p>
          <p className="ff-text-large">{invoice.customerEntity.address.country}</p>
          {this.isEuNonSeCustomer() &&
            <div className="vat-nr">
              <br/>
              <p>{invoice.customerEntity.vatNr}</p>
            </div>
          }
        </div>
      </div>
    );
  }

  renderInvoiceReferenceDetails () {
    let invoice = this.state.invoice;

    return (
      <div>
        <div className="reference-box">
          <div className="ff-text-left">
            <p><Translate content='INVOICE_YOUR_CUSTOMER_NO'/></p>
            <p><Translate content='INVOICE_YOUR_REFERENCE'/></p>
            <p><Translate content='INVOICE_OUR_REFERENCE'/></p>
          </div>
          <div className="ff-text-left">
            <p className="ff-text-bold">{invoice.customerId}</p>
            <p>{invoice.customerEntity.contact || <br/>}</p>
            <p><Translate content='INVOICE_INVOICE_SERVICE'/></p>
          </div>
          <div className="ff-text-left">
            <p className="ff-text-bold"><Translate content='INVOICE_DUE_DATE'/></p>
            <p><Translate content='INVOICE_PAYMENT_TERMS'/></p>
            <p><Translate content='INVOICE_INTEREST_FEE'/></p>
          </div>
          <div className="ff-text-left">
            <p className="ff-text-bold"><Translate content='ADDED_LATER'/></p>
            <p>{invoice.customerEntity.payTerms} <Translate content='INVOICE_DAYS_NET'/></p>
            <p><Translate content='INVOICE_INTEREST_FEE_VALUE'/></p>
          </div>
          <div className="ff-text-left">
            <p><Translate content='INVOICE_PAYMENT_REMINDER_FEE'/></p>
          </div>
        </div>
      </div>
    );
  }

  renderInvoiceDescription () {
    let invoice = this.state.invoice;
    let user = this.state.invoice.invoiceUser[0];
    let dates = this.state.invoice.invoiceDate;
    let displayDates = this.state.invoice.displayDates;
    let displayHours = this.state.invoice.displayHours;
    let dateString = [];

    if (displayDates === 1) {
      for (let i = 0; i < dates.length; i++) {
        let hours = '';
        if (displayHours === 1) {
          hours = ' ' + dates[i].hours + 'h';
        }
        if ((dates.length - 1) === i) {
          dateString.push(<div className="date-string" key={i}><p>{dates[i].date + hours}</p></div>);
        } else {
          dateString.push(<div className="date-string" key={i}><p>{dates[i].date + hours + ', '}</p></div>);
        }
      }
    } else {
      dateString = dateString.splice(0, dateString.length);
      dateString = <div className="date-string"><br/></div>;
    }

    return (
      <div className="description-box">
        <div className="ff-text-left description-text">
          <p>{user.firstName} {user.lastName}</p>
          <div className="date-box">{dateString}</div>
          <p className="specification-text">{invoice.specification}</p>
          {invoice.hsd.rot &&
            <p><Translate content='INVOICE_SPECIFICATION_ROT'/></p>
          }
          {invoice.hsd.rut &&
            <p><Translate content='INVOICE_SPECIFICATION_RUT'/></p>
          }
          <br/>
          {this.isEuNonSeCustomer() &&
            <p><Translate content='INVOICE_IS_EU_CUSTOMER' fallback={' '}/></p>
          }
          {!this.isEuNonSeCustomer() &&
            <p><Translate content='INVOICE_IS_NOT_EU_CUSTOMER' fallback={' '}/></p>
          }
        </div>
        <div className="ff-text-right">
          <p>{this.calculateInvoiceAmounts().netAmount}</p>
        </div>
      </div>
    );
  }

  renderInvoicePayment () {
    let invoice = this.state.invoice;
    let vat = '0 %';
    if (this.calculateInvoiceAmounts().vat && parseInt(this.calculateInvoiceAmounts().vat) !== 0) {
      vat = this.calculateInvoiceAmounts().vat + ' %';
    }

    return (
      <div className="payment-box">
        <div className="ff-text-left">
          <p><Translate content='INVOICE_TOTAL_EXCL_VAT'/></p>
          <p>{this.calculateInvoiceAmounts().netAmount}</p>
        </div>
        <div className="ff-text-left">
          <p><Translate content='INVOICE_VAT_RATE'/></p>
          <p>{vat}</p>
        </div>
        <div className="ff-text-left">
          <p><Translate content='INVOICE_VAT'/></p>
          <p>{Math.round(this.calculateInvoiceAmounts().vatAmount*100)/100}</p>
        </div>
        <div className="ff-text-left">
          <p><Translate content='INVOICE_ROUNDING'/></p>
          <p>{this.calculateInvoiceAmounts().roundedBy || '0'}</p>
        </div>
        <div className="ff-text-left">
          <p><Translate content='CURRENCY'/></p>
          <p className="ff-text-bold">{invoice.currencyName}</p>
        </div>
        <div className="ff-text-right">
          <p className="ff-text-bold"><Translate content='INVOICE_TOTAL_INCL_VAT'/></p>
          <p className="ff-text-bold ff-text-large">{this.calculateInvoiceAmounts().totalAmountRounded}</p>
        </div>
        <div className="ff-text-left">
          <p className="ff-text-bold ff-text-large"><Translate content='INVOICE_PLEASE_ALWAYS'/></p>
          <p className="ff-text-large"><Translate content='INVOICE_COMMENTS_MADE'/></p>
        </div>
      </div>
    );
  }

  isForeignCustomer = () => {
    return typeof this.state.invoice.customerEntity.address.country !== 'undefined' &&
      this.state.invoice.customerEntity.address.country !== 'SWEDEN';
  }

  isEuNonSeCustomer = () => {
    const euCountries = ['AUSTRIA', 'BELGIUM', 'BULGARIA', 'CROATIA', 'CYPRUS',
      'CZECH REPUBLIC', 'DENMARK', 'ESTONIA', 'FINLAND', 'FRANCE',
      'GERMANY', 'GREECE', 'HUNGARY', 'IRELAND', 'ITALY',
      'LATVIA', 'LITHUANIA', 'LUXEMBURG', 'MALTA', 'NETHERLANDS',
      'POLAND', 'PORTUGAL', 'ROMANIA', 'SLOVAKIA', 'SLOVENIA',
      'SPAIN'];
    let isEUCountry = false;
    for (let i = 0; i < euCountries.length; i++) {
      if ((typeof (this.state.invoice.customerEntity.address.country) !== 'undefined') &&
      (this.state.invoice.customerEntity.address.country === euCountries[i])) {
        isEUCountry = true;
        break;
      }
    }
    return isEUCountry;
  }

  calculateInvoiceAmounts () {
    let invoice = this.state.invoice;

    let calcAmount = (invoice.hsd.rot || invoice.hsd.rut) ? invoice.amountAfterHsd : invoice.currencyAmount;

    let netAmount = toMoney(calcAmount, 2);
    let taxableAmount = calcAmount;
    let vat = getVatById(invoice.taxId);
    let vatAmount = calcAmount*(getVatById(invoice.taxId)/100);
    let totalAmount = calcAmount + vatAmount;
    let totalAmountRounded = toMoney(calcAmount + vatAmount, 0);
    let roundedBy = toMoney(totalAmountRounded - totalAmount);

    return {
      netAmount: netAmount,
      taxableAmount: vat === 0 ? '' : taxableAmount,
      vat: vat === 0 ? '' : vat,
      vatAmount: vatAmount === 0 ? '' : vatAmount,
      totalAmount: totalAmount,
      totalAmountRounded: totalAmountRounded,
      roundedBy: roundedBy === 0 ? '' : roundedBy
    };
  }

  renderInvoicePreviewClose () {
    return (
      <div className='btn-close-wrapper'>
        <button className='close' onClick={this.props.closePreviewModal}></button>
      </div>
    );
  }
}

export default PreviewInvoice;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/preview-invoice/preview-invoice.js
 **/